import { useCallback } from 'react';
import { useNotificationStore } from './store';
import MuiDialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';

export default function Image() {
  const { notification, handleClose } = useNotificationStore();

  const onCancel = useCallback(() => {
    handleClose();
    notification.onCancel?.();
  }, [handleClose, notification]);

  if (notification.type !== 'image') return null;

  return (
    <MuiDialog
      open={notification.open ?? false}
      onClose={onCancel}
      aria-labelledby='alert-image-title'
      aria-describedby='alert-image-description'
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: 'rgba(0, 0, 0, 0.8)', // Black with 10% opacity
          },
        },
      }}
      sx={{
        '& .MuiDialogContent-root': {
          padding: 0,
        },
        '& .MuiPaper-root': {
          maxWidth: 'none',
          maxHeight: 'none',
        },
      }}
    >
      <DialogContent>{notification.content}</DialogContent>
    </MuiDialog>
  );
}
